import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'textLimit'
})
export class TextLimitPipe implements PipeTransform {
  transform(value: any, limit: number): any {
   if(value.length>limit){
    return value.substring(0, limit) + '...';
  }
  return value;
  }
}
